import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Entity, Guard, Result, UniqueEntityID } from '@digibricks/domains';
import { AudioFileRule } from './audio-file-rule';
import { AudioFileNumberOfReplays } from './audio-file-number-of-replays';
export var AudioFile = /*#__PURE__*/function (_Entity) {
  _inherits(AudioFile, _Entity);

  var _super = _createSuper(AudioFile);

  function AudioFile(props, id) {
    var _this;

    _classCallCheck(this, AudioFile);

    _this = _super.call(this, props, id);
    _this.props = props;
    return _this;
  }

  _createClass(AudioFile, [{
    key: "rule",
    get: function get() {
      return this.props.rule;
    }
  }, {
    key: "url",
    get: function get() {
      return this.props.url;
    }
  }, {
    key: "size",
    get: function get() {
      return this.props.size;
    }
  }, {
    key: "type",
    get: function get() {
      return this.props.type;
    }
  }, {
    key: "name",
    get: function get() {
      var fileExtension = this.url.split('.').pop();
      return "".concat(this.id.toString().slice(0, 5), ".").concat(fileExtension);
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return {
        id: this.id.toString(),
        url: this.url,
        type: this.type,
        size: this.size,
        name: this.name,
        rule: {
          isAllowedToReplay: this.rule.isAllowedToReplay,
          isAutoPlay: this.rule.isAutoPlay,
          allowingToPauseAndStop: this.rule.allowingToPauseAndStop,
          numberOfReplays: this.rule.numberOfReplays.equals(AudioFileNumberOfReplays["default"]) ? undefined : this.rule.numberOfReplays.value
        }
      };
    }
  }, {
    key: "rules",
    get: function get() {
      return this.props;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(data) {
      var id = data.id,
          url = data.url,
          type = data.type,
          size = data.size,
          rule = data.rule;
      return this.create({
        url: url,
        type: type,
        size: size,
        rule: AudioFileRule.fromJson(rule).getValue()
      }, id);
    }
  }, {
    key: "create",
    value: function create(props, id) {
      var guardCollection = [{
        argument: props.url,
        argumentName: 'Signed Url'
      }, {
        argument: props.size,
        argumentName: 'Size'
      }, {
        argument: props.type,
        argumentName: 'Type'
      }, {
        argument: props.rule,
        argumentName: 'Rules'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return new BadInputError(guardResult.message);
      }

      return Result.ok(new AudioFile(props, new UniqueEntityID(id)));
    }
  }]);

  return AudioFile;
}(Entity);